import React from 'react';
import {Col, Row} from 'antd';
import dayjs from 'dayjs';
import InputFormField from '../../components/data_entry/form/InputFormField';
import SelectFormField from '../../components/data_entry/form/SelectFormField';
import DatePickerFormField from '../../components/data_entry/form/DatePickerFormField';
import {CLIENT_TYPE_OPTIONS, MASK_TYPES_INPUT} from '../../constants/constants';
import {FIELD_NAMES, GENDER_OPTIONS} from './constants';

export default function PersonalDataSection() {
    return (
        <Row gutter={16}>
            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    form={{
                        label: 'Nome',
                        name: FIELD_NAMES.FIRST_NAME,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    placeholder="Seu nome"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    form={{
                        label: 'Sobrenome',
                        name: FIELD_NAMES.LAST_NAME,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    placeholder="Seu sobrenome"
                />
            </Col>

            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    maskType={MASK_TYPES_INPUT.CPF}
                    form={{
                        label: 'CPF',
                        name: FIELD_NAMES.CPF,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    placeholder="000.000.000-00"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    form={{
                        label: 'RG',
                        name: FIELD_NAMES.RG,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    placeholder="Seu RG"
                />
            </Col>

            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    form={{
                        label: 'Profissão',
                        name: FIELD_NAMES.PROFESSION,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    placeholder="Sua profissão"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <DatePickerFormField
                    defaultPickerValue={dayjs().subtract(18, 'year')}
                    form={{
                        label: 'Data de Nascimento',
                        name: FIELD_NAMES.BIRTH_DATE,
                        rules: [
                            {required: true, message: 'Campo obrigatório'},
                            () => ({
                                validator(_, value) {
                                    if (!value) return Promise.resolve();
                                    const today = new Date();
                                    const birth = value.toDate ? value.toDate() : new Date(value);
                                    let age = today.getFullYear() - birth.getFullYear();
                                    const monthDiff = today.getMonth() - birth.getMonth();
                                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
                                        age--;
                                    }
                                    if (age < 18) {
                                        return Promise.reject(new Error('É necessário ter no mínimo 18 anos'));
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ],
                    }}
                    placeholder="Selecione a data"
                />
            </Col>

            <Col xs={24} sm={12} lg={8}>
                <SelectFormField
                    form={{
                        label: 'Gênero',
                        name: FIELD_NAMES.GENDER,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    options={GENDER_OPTIONS}
                    placeholder="Selecione"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    maskType={MASK_TYPES_INPUT.PHONE_NUMBER}
                    form={{
                        label: 'Telefone',
                        name: FIELD_NAMES.PHONE,
                    }}
                    placeholder="(00) 00000-0000"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <SelectFormField
                    form={{
                        label: 'Tipo de Associado',
                        name: FIELD_NAMES.CLIENT_TYPE,
                        rules: [{required: true, message: 'Campo obrigatório'}],
                    }}
                    options={CLIENT_TYPE_OPTIONS}
                    placeholder="Selecione o tipo"
                />
            </Col>
        </Row>
    );
}
